import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import TweenLite from "gsap/TweenLite";
import { Back } from "gsap";

export default class WorldCreation extends PureComponent {
  constructor() {
    super();

    this.state = {
      creationData: {
        worldName: "",
        purpose: "",
        siteName: "",
      },
      requestSent: false,
    };
  }

  handleFocus = (event) => {
    const el = event.target.parentElement;
    const an = el.children[0];

    TweenLite.to(an, 0.1, { y: 0, autoAlpha: 1 });
  };

  handleBlur = (event) => {
    const el = event.target.parentElement;
    const an = el.children[0];

    TweenLite.to(an, 0.075, {
      y: 5,
      autoAlpha: 0,
      ease: Back.linear,
      delay: 0.025,
    });
  };

  onChange = (e) => {
    let { name, value } = e.target;

    if (name === "worldName") {
      if (value.match(/[^a-zA-Z0-9]/g)) {
        value = value.replace(/[^a-zA-Z0-9]/g, "");
      }
    }

    this.setState((prevState) => {
      return {
        creationData: {
          ...prevState.creationData,
          [name]: value,
        },
      };
    });
  };

  onCreateWorld = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      return { requestSent: !prevState.requestSent };
    });

    this.props.createWorld(this.state.creationData).then((res) => {
      this.setState((prevState) => {
        return { requestSent: !prevState.requestSent };
      });

      res &&
        this.setState(() => {
          return {
            creationData: {
              worldName: "",
              purpose: "",
              siteName: "",
            },
          };
        });
    });
  };

  render() {
    const { worldName, purpose, siteName } = this.state.creationData;
    return (
      <div className="flex flex-items-center flex-justify-center wc__container">
        <div className="metrics__container">
          <div className={`shadow metrics__wrapper`}>
            <h3>Create a new World</h3>
            <hr />

            <form
              className="signup_form"
              method="post"
              onSubmit={(e) => this.onCreateWorld(e)}
            >
              <div className={`flex flex-wrap formRow`}>
                <div
                  className="formItemFull"
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <label className="formLabel" htmlFor="worldName">
                    World Name
                  </label>
                  <input
                    type="text"
                    className={`input__one account__input`}
                    name="worldName"
                    id="worldName"
                    placeholder="Enter a World Name (5-32 alphanumeric)"
                    value={worldName}
                    onChange={(e) => this.onChange(e)}
                    required
                  />
                </div>
              </div>
              <div className={`flex flex-wrap formRow`}>
                <div
                  className="formItemFull"
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <label className="formLabel" htmlFor="purpose">
                    Purpose
                  </label>
                  <input
                    type="text"
                    className={`input__one account__input`}
                    name="purpose"
                    id="purpose"
                    value={purpose}
                    onChange={(e) => this.onChange(e)}
                    placeholder="Describe how you will use this world."
                    required
                  />
                </div>
              </div>

              {/* <div className={`flex flex-wrap formRow`}>
                <div
                  className="formItemFull"
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                >
                  <label className="formLabel" htmlFor="siteName">
                    Site Name
                  </label>
                  <input
                    type="text"
                    className={`input__one account__input`}
                    name="siteName"
                    id="siteName"
                    value={siteName}
                    onChange={(e) => this.onChange(e)}
                    placeholder="Enter your Site Name"
                    // required
                  />
                </div>
              </div> */}

              <button
                type="submit"
                className="loginBtn button"
                disabled={this.state.requestSent ? "disabled" : ""}
              >
                {this.state.requestSent ? "Creating . . ." : "Create"}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

WorldCreation.propTypes = {
  createWorld: PropTypes.func.isRequired,
};
